export default __webpack_public_path__ + "static/media/plant.4bc69876.png";